const apiUrl = 'https://mtbapi.nf.validoapp.com';

export const environment = {
  production: false,
  api: {
    version: '20',
    url: apiUrl
  },
  legacyFrontend: {
    url: 'https://mtbappweb.nf.validoapp.com/'
  },
  customerForms: {
    domain: 'https://customer.humanstars.app'
  },
  customerHostRouting: {
    enabled: false,
    protocol: 'https',
    baseDomain: 'humanstars.app',
    defaultSubdomain: 'web'
  },
  firebase: {
    active: true,
    setupLogs: true,
    config: {
      projectId: 'humanstarsapp',
      appId: '1:510685239618:web:a15824dc6d61400950d0db',
      databaseURL: 'https://humanstarsapp.firebaseio.com',
      storageBucket: 'humanstarsapp.appspot.com',
      apiKey: 'AIzaSyBlmQ8Eq0lVlpvPLbsbW0E-xR4qH49grmE',
      authDomain: 'humanstarsapp.firebaseapp.com',
      messagingSenderId: '510685239618',
      measurementId: 'G-F0V852MNVB'
    },
    vapidKey: 'BBOHBsJkS4qBFNVY9aQGDsiNYyt30lEpehCn1Pgo9z49lYpYb4Ai7KJb2Mn4JGmVWHKB3XJHtvHxKJr55quTlwg'
  },
  sentry: {
    environment: 'development',
    traceSampleRate: 1.0,
    traceTargets: [apiUrl, 'localhost', /^\/api\//],
    replaySampleRate: 0.0,
  },
  writeSocketDebugLogs: true,
  tokenRefreshRemainingSeconds: 300
};
